import MainLayout from 'components/layout/Main';
import FinanceFooter from 'components/shared/FinanceFooter';
import { EnquiryHeader } from 'pages/Enquiry/components';
import EnquiryLayoutSidebar from 'pages/Enquiry/components/Sidebar';
import ApplySteps from 'pages/Enquiry/components/Steps';
import EnquiryWelcomeContent from 'pages/Enquiry/Welcome/Content';
import useShortUrl from './useShortUrl';

const ShortUrl: React.FunctionComponent = function () {
  useShortUrl();
  return (
    <MainLayout
      headerContent={EnquiryHeader}
      sidebarContent={<EnquiryLayoutSidebar isLoading />}
      footer={<FinanceFooter marginClassName="px-6 md:px-12 pt-8 !text-left" />}
    >
      <div className="flex flex-col flex-1 py-8 px-6 md:px-10 lg:px-15">
        <div className="flex flex-1 flex-row gap-x-8">
          <div className="hidden lg:block relative w-50 min-w-50">
            <div className="sticky top-26">
              <ApplySteps isLoading />
            </div>
          </div>
          <div className="flex w-full">
            <div className="flex flex-col w-full max-w-120 mx-auto">
              <EnquiryWelcomeContent
                onClick={() => {}}
                tradingName=""
                isLoading
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ShortUrl;
